import { datadogRum } from '@datadog/browser-rum';

interface RumConfig {
    applicationId: string;
    clientToken: string;
    site: string;
    service: string;
    env: string;
    version: string;
    sampleRate: number;
    trackInteractions: boolean;
    replaySampleRate: number;
}

declare global {
    interface Window {
        initializeDatadogRum?: (config: RumConfig) => void;
    }
}

window.initializeDatadogRum = function (config: RumConfig) {
    datadogRum.init({
        applicationId: config.applicationId,
        clientToken: config.clientToken,
        site: 'datadoghq.com',
        service: config.service,
        env: config.env, 
        sessionSampleRate: config.sampleRate || 10,
        sessionReplaySampleRate: config.replaySampleRate || 0,
        trackUserInteractions: true,
        trackResources: false,
        trackLongTasks: false,
        defaultPrivacyLevel: 'mask-user-input',
    });

    if (config.replaySampleRate > 0) {
        datadogRum.startSessionReplayRecording();
    }
};